// extracted by mini-css-extract-plugin
export default {"button":"Sq","primary":"Tq","fullWidth":"Uq","secondary":"Vq","nutrition":"Wq","underlined":"Xq","small":"Yq","medium":"Zq","info":"ar","white":"br","border":"cr","mango":"er","charcoal":"fr","court":"gr","green":"hr","spark":"ir","linkButton":"jr","disabled":"kr"};
    if(module.hot) {
      // 1721922359633
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  